import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ItemAssignmentForm} from 'src/app/item-tracker/ItemAssignmentForm';
import {itemAssignmentDocumentTitle} from 'src/app/item-tracker/itemAssignmentHelpers';

const ItemAssignmentEditPage: React.FC = () => {
  useSetDocumentTitle(`${itemAssignmentDocumentTitle} - Edit`);

  const {definitionId, id} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.ItemTracker}>
      {id !== undefined && (
        <ItemAssignmentForm
          definitionId={Number(definitionId)}
          id={Number(id)}
          mode="edit"
          enableEdit={true}
          enableTransitions={true}
        />
      )}
    </ContentWrapper>
  );
};

export default ItemAssignmentEditPage;

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ItemAssignmentEdit(':definitionId', ':id'),
  element: <ItemAssignmentEditPage />,
  isPrivate: true,
  module: ModuleEnum.ItemTrackerAssignments,
  operation: PermissionOperationEnum.Update,
});
